import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogTitleOptions, DialogContentOptions, ConfirmationTextOptions, CancellTextOptions } from './leave-confirm-dialog-options';
import { DialogActionsContainer, StyledDialogContent, StyledDialogTitle, StyledNotifDialogContent } from '../shared-styles/dialog-title-styles';
import { StyledButton } from '../styled-button/styled-button';

type IProps = {
  handleLeave: () => void;
  handleClose: () => void;
  open: boolean;
};

export default function LeaveConfirmDialog(props: IProps) {
  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          props.handleClose();
        }
      }}
      disableEscapeKeyDown
      aria-describedby="leave-confirm-dialog"
    >
      <StyledDialogTitle id="form-dialog-title">
        <DialogTitleOptions />
      </StyledDialogTitle>
      <StyledNotifDialogContent>
      <DialogContentOptions />
      </StyledNotifDialogContent>
      <DialogActionsContainer>
        <StyledButton variant="contained"
            sx={{ bgcolor: `primary.darker`, color: `primary.light` }}
            onClick={() => void props.handleClose()} >
          <CancellTextOptions />
        </StyledButton>
        <StyledButton variant="contained" 
            sx={{ textTransform: "none" }} 
            onClick={props.handleLeave ? props.handleLeave : undefined} >
          <ConfirmationTextOptions />
        </StyledButton>
      </DialogActionsContainer>
    </Dialog>
  );
}